import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

const ICONS = {
  conform: <CheckCircle2 className="text-emerald-600 shrink-0" size={18} />,
  warning: <AlertTriangle className="text-amber-600 shrink-0" size={18} />,
  blocker: <XCircle className="text-[#E1000F] shrink-0" size={18} />,
};

export default function CompliancePanel({ result }) {
  if (!result) return null;
  const score = result.score;
  const color = score >= 90 ? "#059669" : score >= 70 ? "#d97706" : "#E1000F";
  return (
    <div className="card-flat p-6" data-testid="compliance-panel">
      <div className="flex items-center gap-6 mb-5">
        <div className="relative w-24 h-24 shrink-0">
          <svg viewBox="0 0 36 36" className="w-24 h-24 -rotate-90">
            <path d="M18 2 a16 16 0 1 1 0 32 a16 16 0 1 1 0 -32" fill="none" stroke="#e4e4e7" strokeWidth="3" />
            <path d="M18 2 a16 16 0 1 1 0 32 a16 16 0 1 1 0 -32" fill="none" stroke={color} strokeWidth="3"
              strokeDasharray={`${score}, 100`} strokeLinecap="round" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-2xl font-black font-display" style={{ color }}>{score}</span>
            <span className="text-[9px] text-slate-400">/ 100</span>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">Score de conformité</div>
          <div className="text-2xl font-black font-display" style={{ color }}>{result.level}</div>
          {result.regulation && (
            <div className="text-xs text-slate-500 mt-1">Réf. {result.regulation.name} (v{result.regulation.version})</div>
          )}
        </div>
      </div>

      <div className="space-y-2">
        {result.points?.map((p, i) => (
          <div key={i} className="flex items-start gap-2 text-sm" data-testid="compliance-point">
            {ICONS[p.status]}
            <span className={p.status === "blocker" ? "text-[#E1000F] font-medium" : "text-slate-700"}>{p.label}</span>
          </div>
        ))}
      </div>

      {result.recommendations?.length > 0 && (
        <div className="mt-5 pt-4 border-t border-border">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Recommandations</div>
          <ul className="list-disc pl-5 space-y-1 text-sm text-slate-600">
            {result.recommendations.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
